module.exports = __webpack_public_path__ + "static/media/tree_23.f92b94d7.jpeg";